
export const articleChangeImportanceValues = ['low', 'medium', 'high'] as const;
export type ArticleChangeImportance = typeof articleChangeImportanceValues[number];

export const releaseRecordStates = ['pending', 'success', 'silent-success', 'failure'] as const;
export type ReleaseRecordStatus = typeof releaseRecordStates[number];

export const requirementsStates = ['0 - missing', '1 - defined', '2 - not required'] as const;
export type RequirementsStatus = typeof requirementsStates[number];

export const baseArticleFieldNames = ['typeId', 'topicId', 'requirements'] as const;
export type BaseArticleFieldName = typeof baseArticleFieldNames[number];
export type BaseArticleChange = { field: BaseArticleFieldName, value: string; };

export const articleVersionFieldNames = ['title', 'description', 'reference', 'date', 'url', 'importance', 'changeDescription', 'assessment'] as const;
export type ArticleVersionFieldName = typeof articleVersionFieldNames[number];
export type ArticleVersionChange = { field: ArticleVersionFieldName, value: string | Date | null; };

export const articleFieldNames = [...baseArticleFieldNames, ...articleVersionFieldNames] as const;
export type ArticleFieldName = typeof articleFieldNames[number];
export type ArticleFieldChange = BaseArticleChange | ArticleVersionChange;

export const internalArticleFieldNames = ['title', 'description', 'ownerUserId', 'date', 'evaluationImportance', 'evaluationText', 'changeDescription'] as const;
export type InternalArticleFieldName = typeof internalArticleFieldNames[number];
export type InternalArticleFieldChange = { field: InternalArticleFieldName, value: string | Date | null; };

export const appendixFieldNames = ['typeId', 'topicId', 'title', 'description', 'reference', 'date', 'url'] as const;
export type AppendixFieldName = typeof appendixFieldNames[number];
export type AppendixFieldChange = { field: AppendixFieldName, value: string | Date | null; };

export const articleTags = [
    '{company.name}'
];
export type ArticleTag = typeof articleTags[number];

export const articleEmailTags = [ 
    '{company.siteId}',
    '{company.name}',
    '{contactperson.firstname}',
    '{contactperson.fullname}',
    '{article.url}',
    '{article.title}',
    '{article.listname}'] as const;
export type ArticleEmailTag = typeof articleEmailTags[number];